<template>
    <div class="function-group inlineblock-meaningless-wrapper">
        <PtDropdown v-clickoutside="() => this.$refs.shareDropdown.hide()" ref="shareDropdown" trigger="click" @command="onCommand">
            <ElasticButton :title="$t('More')" :alwaysNeedTooltip="true" :disabled="false" class="function-group__trigger" @click="isTriggeredDropdown = true">
                <template slot="icon">
                    <PtIcon icon="SolidMoreVertical" />
                </template>
                <input ref="copyInput" class="function-group__copy" type="text" @click="copy()" />
            </ElasticButton>
            <PtDropdownMenu v-addIframe="{ padding: 1 }" slot="dropdown" class="function-group__menu">
                <slot name="prepend" />
                <!--fileWrapperAlert 需要将list请求后置-->
                <PtDropdownItem v-if="acls.has('fileWrapperAlert') && patent.can_alert_file_wrapper && isTriggeredDropdown" :command="() => undefined" key="fileWrapper">
                    <FireWrapperAlertComplex :patent-id="patentId" :patent="patent" :disabledTooltip="true" :getListTiming="'mounted'" />
                </PtDropdownItem>
                <!--quickSave-->
                <PtDropdownItem v-if="acls.has('addToWorkspace')" :command="() => undefined" key="quickSave">
                    <ElasticButton
                        :async-click="() => savedFolderId ? deleteFromQuickSave() : quickSave()"
                        :isLoading="preparingStatus"
                        :title="$t('growth.QuickSavePatents.quickSaveBtn')"
                        :disabled="false"
                        :disabledTooltip="true"
                        class="pendo-track__function-bar__quick-save"
                    >
                        <PtIcon :class="{ shine: savedFolderId }" slot="icon" icon="SolidStar"/>
                        <template slot="text">{{$t('growth.QuickSavePatents.quickSaveBtn')}}</template>
                    </ElasticButton>
                </PtDropdownItem>
                <!--email-->
                <PtDropdownItem
                    v-if="acls.has('email') && !highLevel && renderViewDatas"
                    :command="shareByEmail"
                    key="SolidEmail"
                    class="pendo-track__function-bar__share-by-email">
                    <PtIcon icon="SolidEmail"/>
                    <span class="function-group__dropdown-item">{{$t('toolbar.email')}}</span>
                </PtDropdownItem>
                <!--copy-->
                <PtDropdownItem
                    v-if="hasCopyLink"
                    :command="() => undefined"
                    key="shareByClipboard"
                    class="pendo-track__function-bar__share-by-clipboard">
                    <ElasticButton
                        :disabled="shareDisabled"
                        :disabledTooltip="true"
                        :async-click="shareByClipboard"
                    >
                        <PtIcon slot="icon" icon="SolidChain"/>
                        <template slot="text">{{$t('toolbar.copy')}}</template>
                    </ElasticButton>
                </PtDropdownItem>
            </PtDropdownMenu>
        </PtDropdown>
        <EmailToFriendDialog
            mount-point=".patent-view-app"
            v-if="showEmailToFriendDialog && renderViewDatas"
            :show-dialog.sync="showEmailToFriendDialog"
            :render-view-datas="renderViewDatas" />
        <workspace-alert
            :count="1"
            :visible="showWorkspaceAlert"
            :folder-name="workspaceFolder"
            :folder-id="workspaceFolderId"
            :space-id="workspaceSpaceId"
            :onClose="() => (showWorkspaceAlert = false)" />
    </div>
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'patsnap-ui';
import { Icon, Toast as PtToast } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/MoreVertical.svg';
import '@patsnap-ui/icon/assets/solid/star.svg';
import '@patsnap-ui/icon/assets/solid/email.svg';
import '@patsnap-ui/icon/assets/solid/chain.svg';
import { get, isEmpty } from 'lodash';
import { AlertMixin } from 'library-@/mixins';
import { RavenInsertMeta } from 'library-@/services/sentry';
import { quickSaveEnhanceApi, deleteQuickSavePatentsApi, quickSaveStatusApi } from '../../../../../components/apis/workspace_api/folder';
import ElasticButton from './ElasticButton';
import EmailToFriendDialog from '@/components/email-to-friend';
import clickoutside from 'element-ui/src/utils/clickoutside';
import addIframe from '../../directives/addIframe';
import FireWrapperAlertComplex from './FireWrapperAlertComplex';
import WorkspaceAlert from '@/components/growth/WorkspaceAlert';
import { getViewParams } from 'library-@/utils/get-params';
import CompareFunctionGroup from '@/mixins/compare-function-group';
import { getPatentShareSignApi } from 'library-@/apis/core_basic_api/view';
import Bowser from 'bowser';

export default {
    name: 'FunctionGroup',
    mixins: [AlertMixin, CompareFunctionGroup],
    props: {
        acls: {
            type: Set,
            default() {
                return new Set();
            }
        },
        patentId: {
            type: String,
            required: true
        },
        patent: {
            type: Object,
        }
    },
    components: {
        ElasticButton,
        WorkspaceAlert,
        EmailToFriendDialog,
        FireWrapperAlertComplex,
        'PtDropdown': Dropdown,
        'PtDropdownMenu': DropdownMenu,
        'PtDropdownItem': DropdownItem,
        'PtIcon': Icon,
        PtToast,
    },
    directives: {
        clickoutside,
        addIframe
    },
    computed: {
        renderViewDatas() {
            if (isEmpty(this.patent)) {
                return undefined;
            }
            const info = { ...this.patent };
            if (info.IN) info.IN = info.IN[info.LANG_DEFAULT];
            if (info.TITLE) info.TITLE = info.TITLE[info.LANG_DEFAULT];
            if (info.AN) info.AN = info.AN[info.LANG_DEFAULT];
            return info;
        },
        highLevel() {
            return get(window, 'zPREFACE.globalConfig.whiteLabel.highLevel', false);
        },
        shareDisabled() {
            return get(this.patent, 'high_value_patent', false);
        },
        hasCopyLink() {
            return this.acls.has('share') && !this.highLevel;
        }
    },
    methods: {
        onCommand(func) {
            func();
        },
        openDropdown() {
            this.$refs.shareDropdown.hide();
        },
        closeDropdown() {
            this.$refs.shareDropdown.hide();
        },
        copy() {
            $(this.$refs.copyInput).focus().select();
            document.execCommand('copy', false, null);
        },
        shareByEmail() {
            this.showEmailToFriendDialog = true;
        },
        async getSignStr() {
            try {
                const { signature, from, date, expire, shareId, version } = await getPatentShareSignApi(this.patentId);
                this.signStr = `&signature=${signature}&from=${from}&date=${date}&expire=${expire}&shareId=${shareId}&version=${version}`;
            } catch (error) {
                console.log('error', error);
            }
        },
        async shareByClipboard() {
            if (!this.signStr) await this.getSignStr();

            const protocolUrl = window.location.protocol;
            const shareUrl = `${protocolUrl}//${window.location.hostname}/patent-view/abst?patentId=${this.patentId}${this.signStr}`;

            const traditionCopy = () => {
                let dom = this.$refs.copyInput;
                dom.value = shareUrl;
                this.$nextTick(() => {
                    dom.click();
                    this.successAlert(this.$t('ShareOK'));
                });
            };

            if (get(navigator, 'clipboard.writeText')) {
                navigator.clipboard.writeText(shareUrl)
                    .then(() => {
                        this.successAlert(this.$t('ShareOK'));
                    }, traditionCopy);
            } else {
                traditionCopy();
            }
            window.rvTrack('Shared Patent', {
                source: '/patent-view',
                sharing_channel: 'copied link'
            });
        },
        async quickSave() {
            this.preparingStatus = true;
            // 发起保存请求
            let patentId = this.patentId;
            let bioUk = get(getViewParams(), 'bio_uk');
            bioUk = bioUk ? bioUk.split(',') : [];
            try {
                // 添加来源spaceId/folderId
                // eslint-disable-next-line camelcase
                const { workspace_id, folder_id } = this.$route.query;

                const result = await quickSaveEnhanceApi({
                    patent_ids: [patentId],
                    bio_uk: bioUk,
                    from_space_id: workspace_id,
                    from_folder_id: folder_id,
                }).finally(() => this.preparingStatus = false);
                if (result.status === 1) {
                    this.savedFolderId = result.folder_id;
                    RavenInsertMeta('Growth Eng', 'Save To Workspace', {
                        folder_location: result.folder_name,
                        page: 'Patent View',
                        source: 'button'
                    });
                    this.workspaceFolder = result.folder_name;
                    this.workspaceFolderId = result.folder_id;
                    this.workspaceSpaceId = result.space_id;
                    this.showWorkspaceAlert = true;
                    setTimeout(() => {
                        this.showWorkspaceAlert = false;
                    }, 3000);
                } else if (result.status === 2) {
                    this.savedFolderId = undefined;
                    this.warnAlert(this.$t('growth.QuickSavePatents.exceedLimit'));
                } else {
                    this.savedFolderId = undefined;
                    this.warnAlert(this.$t('growth.QuickSavePatents.saveFailed'));
                }
            } catch (error) {
                let errorMsg = error._error_msg || this.$t('commonStatusCode.400');
                PtToast({
                    message: errorMsg,
                    type: 'error',
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                });
            }
        },
        async deleteFromQuickSave() {
            let patentId = this.patentId;
            this.preparingStatus = true;
            this.showWorkspaceAlert = false;

            deleteQuickSavePatentsApi({
                folder_id: this.savedFolderId,
                patent_id: patentId
            })
                .then(() => this.savedFolderId = undefined)
                .finally(() => this.preparingStatus = false);
        }
    },
    watch: {
        patentId: {
            immediate: true,
            async handler(newVal) {
                if (!this.acls.has('addToWorkspace')) return;
                this.preparingStatus = true;
                this.savedFolderId = undefined;
                quickSaveStatusApi({ patent_ids: [newVal] })
                    .then(data => {
                        this.savedFolderId = get(data, 'all_in') ? get(data, 'folder_id') : undefined;
                    })
                    .finally(() => this.preparingStatus = false);
            }
        },
        hasCopyLink: {
            immediate: true,
            handler(newVal) {
                if (newVal && !this.signStr) {
                    const browser = Bowser.getParser(window.navigator.userAgent);
                    const { name } = browser.getBrowser();
                    const isSafari = (name === 'Safari');
                    if (isSafari) this.getSignStr();
                }
            }
        }
    },
    data () {
        return {
            showEmailToFriendDialog: false,
            preparingStatus: false,
            quickSaveTipVisible: false,
            savedFolderId: undefined,
            isShowedTip: false,
            showWorkspaceAlert: false,
            workspaceFolder: '',
            workspaceFolderId: '',
            workspaceSpaceId: '',
            isTriggeredDropdown: false,
            signStr: ''
        };
    }
};
</script>

<style lang="scss">
    .function-group__copy{
        padding: 0 !important;
        opacity: 0;
        width: 1em;
        height: 1em;
        position: absolute;
        top:0;
        right: 0;
        z-index: -1;
    }
    .function-group__menu {
        .elstc-btn {
            padding: 0;
            width: 100%;
            border-radius: 0;
            &:active {
                background-color: transparent;
            }
            .eb-pre-text {
                display: inline-block;
            }
        }
        .function-group__dropdown-item {
            display: inline-block;
            vertical-align: middle;
        }
    }
    .function-group__trigger {
        padding: 4px;
        .eb-pre-text {
            display: none;
        }
    }
</style>
